<div class="form-group phone-input-wrapper">
    <label *ngIf="label && !hideLabel" [for]="inputId">{{ label }} <span class="required"
            *ngIf="required">*</span></label>
    <div class="phone-input-container"
        [ngClass]="{'input-error': errorMessage && showError && (phoneNumber.length === 0 || !phoneNumber || (phoneNumber.length > 0 && phoneNumber.length < minLength))}">
        <div class="prefix-dropdown">
            <select class="prefix-select" [(ngModel)]="selectedCountry" [disabled]="disabled"
                (change)="onCountryChange($event)">
                <option *ngFor="let country of countries" [value]="country.code">
                    {{country.name}} ({{'+' + getCountryCallingCode(country.code)}})
                </option>
            </select>
            <div class="selected-display">
                <span>{{phonePrefix}}</span>
                <i class="dropdown-arrow"></i>
            </div>
        </div>
        <input type="tel" [id]="inputId" [name]="inputName" class="form-control phone-input" [placeholder]="placeholder"
            [disabled]="disabled" [(ngModel)]="phoneNumber" (input)="formatPhoneNumber($event)" (blur)="onTouched()">
    </div>
    <div class="error-message" *ngIf="errorMessage && showError && (phoneNumber.length === 0 || !phoneNumber)">
        {{ errorMessage }}
    </div>
    <div class="error-message"
        *ngIf="phoneNumber && phoneNumber.length > 0 && phoneNumber.length < minLength && showError">
        {{ 'common.phoneNumberTooShort' | translate }}
    </div>
</div>